__turbopack_context__.v({
  "amethyst": "text-colors-module-scss-module__QlUAxW__amethyst",
  "amethyst--lg": "text-colors-module-scss-module__QlUAxW__amethyst--lg",
  "amethyst--md": "text-colors-module-scss-module__QlUAxW__amethyst--md",
  "amethyst--modal-button-layout-shift": "text-colors-module-scss-module__QlUAxW__amethyst--modal-button-layout-shift",
  "amethyst--sm": "text-colors-module-scss-module__QlUAxW__amethyst--sm",
  "amethyst--tablet": "text-colors-module-scss-module__QlUAxW__amethyst--tablet",
  "amethyst--xl": "text-colors-module-scss-module__QlUAxW__amethyst--xl",
  "amethyst--xs": "text-colors-module-scss-module__QlUAxW__amethyst--xs",
  "amethyst--xxs": "text-colors-module-scss-module__QlUAxW__amethyst--xxs",
  "black": "text-colors-module-scss-module__QlUAxW__black",
  "black--lg": "text-colors-module-scss-module__QlUAxW__black--lg",
  "black--md": "text-colors-module-scss-module__QlUAxW__black--md",
  "black--modal-button-layout-shift": "text-colors-module-scss-module__QlUAxW__black--modal-button-layout-shift",
  "black--sm": "text-colors-module-scss-module__QlUAxW__black--sm",
  "black--tablet": "text-colors-module-scss-module__QlUAxW__black--tablet",
  "black--xl": "text-colors-module-scss-module__QlUAxW__black--xl",
  "black--xs": "text-colors-module-scss-module__QlUAxW__black--xs",
  "black--xxs": "text-colors-module-scss-module__QlUAxW__black--xxs",
  "default": "text-colors-module-scss-module__QlUAxW__default",
  "default--lg": "text-colors-module-scss-module__QlUAxW__default--lg",
  "default--md": "text-colors-module-scss-module__QlUAxW__default--md",
  "default--modal-button-layout-shift": "text-colors-module-scss-module__QlUAxW__default--modal-button-layout-shift",
  "default--sm": "text-colors-module-scss-module__QlUAxW__default--sm",
  "default--tablet": "text-colors-module-scss-module__QlUAxW__default--tablet",
  "default--xl": "text-colors-module-scss-module__QlUAxW__default--xl",
  "default--xs": "text-colors-module-scss-module__QlUAxW__default--xs",
  "default--xxs": "text-colors-module-scss-module__QlUAxW__default--xxs",
  "dim": "text-colors-module-scss-module__QlUAxW__dim",
  "dim--lg": "text-colors-module-scss-module__QlUAxW__dim--lg",
  "dim--md": "text-colors-module-scss-module__QlUAxW__dim--md",
  "dim--modal-button-layout-shift": "text-colors-module-scss-module__QlUAxW__dim--modal-button-layout-shift",
  "dim--sm": "text-colors-module-scss-module__QlUAxW__dim--sm",
  "dim--tablet": "text-colors-module-scss-module__QlUAxW__dim--tablet",
  "dim--xl": "text-colors-module-scss-module__QlUAxW__dim--xl",
  "dim--xs": "text-colors-module-scss-module__QlUAxW__dim--xs",
  "dim--xxs": "text-colors-module-scss-module__QlUAxW__dim--xxs",
  "future-fuscia": "text-colors-module-scss-module__QlUAxW__future-fuscia",
  "future-fuscia--lg": "text-colors-module-scss-module__QlUAxW__future-fuscia--lg",
  "future-fuscia--md": "text-colors-module-scss-module__QlUAxW__future-fuscia--md",
  "future-fuscia--modal-button-layout-shift": "text-colors-module-scss-module__QlUAxW__future-fuscia--modal-button-layout-shift",
  "future-fuscia--sm": "text-colors-module-scss-module__QlUAxW__future-fuscia--sm",
  "future-fuscia--tablet": "text-colors-module-scss-module__QlUAxW__future-fuscia--tablet",
  "future-fuscia--xl": "text-colors-module-scss-module__QlUAxW__future-fuscia--xl",
  "future-fuscia--xs": "text-colors-module-scss-module__QlUAxW__future-fuscia--xs",
  "future-fuscia--xxs": "text-colors-module-scss-module__QlUAxW__future-fuscia--xxs",
  "negative": "text-colors-module-scss-module__QlUAxW__negative",
  "primary": "text-colors-module-scss-module__QlUAxW__primary",
  "primary--lg": "text-colors-module-scss-module__QlUAxW__primary--lg",
  "primary--md": "text-colors-module-scss-module__QlUAxW__primary--md",
  "primary--modal-button-layout-shift": "text-colors-module-scss-module__QlUAxW__primary--modal-button-layout-shift",
  "primary--sm": "text-colors-module-scss-module__QlUAxW__primary--sm",
  "primary--tablet": "text-colors-module-scss-module__QlUAxW__primary--tablet",
  "primary--xl": "text-colors-module-scss-module__QlUAxW__primary--xl",
  "primary--xs": "text-colors-module-scss-module__QlUAxW__primary--xs",
  "primary--xxs": "text-colors-module-scss-module__QlUAxW__primary--xxs",
  "springtime": "text-colors-module-scss-module__QlUAxW__springtime",
  "springtime--lg": "text-colors-module-scss-module__QlUAxW__springtime--lg",
  "springtime--md": "text-colors-module-scss-module__QlUAxW__springtime--md",
  "springtime--modal-button-layout-shift": "text-colors-module-scss-module__QlUAxW__springtime--modal-button-layout-shift",
  "springtime--sm": "text-colors-module-scss-module__QlUAxW__springtime--sm",
  "springtime--tablet": "text-colors-module-scss-module__QlUAxW__springtime--tablet",
  "springtime--xl": "text-colors-module-scss-module__QlUAxW__springtime--xl",
  "springtime--xs": "text-colors-module-scss-module__QlUAxW__springtime--xs",
  "springtime--xxs": "text-colors-module-scss-module__QlUAxW__springtime--xxs",
  "white": "text-colors-module-scss-module__QlUAxW__white",
  "white--lg": "text-colors-module-scss-module__QlUAxW__white--lg",
  "white--md": "text-colors-module-scss-module__QlUAxW__white--md",
  "white--modal-button-layout-shift": "text-colors-module-scss-module__QlUAxW__white--modal-button-layout-shift",
  "white--sm": "text-colors-module-scss-module__QlUAxW__white--sm",
  "white--tablet": "text-colors-module-scss-module__QlUAxW__white--tablet",
  "white--xl": "text-colors-module-scss-module__QlUAxW__white--xl",
  "white--xs": "text-colors-module-scss-module__QlUAxW__white--xs",
  "white--xxs": "text-colors-module-scss-module__QlUAxW__white--xxs",
});
